import { type GoalOverview, GoalOverviewLifecycleStatus, GoalOverviewProgressStatus } from "Infrastructure/ApiZfp/Schema";

/** Colour scheme of a goal's icon tile and axis marker; an archived goal stays grey even when completed. */
export type GoalTone = "active" | "completed" | "archived";

export const getGoalTone = ({ lifecycleStatus, progressStatus }: GoalOverview): GoalTone => {
  if (lifecycleStatus === GoalOverviewLifecycleStatus.archived) return "archived";
  return progressStatus === GoalOverviewProgressStatus.completed ? "completed" : "active";
};
